export default __webpack_public_path__ + "static/media/table-mobile@2x.427321d1.png";